import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-terms',
  templateUrl: './static-terms.component.html',
  styleUrls: ['./static-terms.component.css']
})
export class StaticTermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
